import styled, { css } from 'styled-components';
import { Atom } from 'AppReact';

export const template = styled.input`
  ${({ theme }) => css`
    width: 100%;
    height: 40px;
    border-radius: 8px 8px 0px 0px;
    background: #F7F7F7;
    border-bottom: 1px solid #E3E3E3;
    outline: none;
    padding-left: 15px;

    color: #9EACB0;
    font-size: 12px;
    line-height: 14px;

    ::placeholder {
      font-size: 12px;
      line-height: 14px;
      color: #9EACB0;
    }
    
    &:focus {
      background: #FFFFFF;
      border: 1px solid ${theme?.colour?.primary};
      color: ${theme?.colour?.secondary};
    }
  `}
`;

export default Atom({ type: 'input', dataType: 'string', template })
